<script setup>
import { ref, onMounted, defineProps, defineModel, watch } from 'vue' 
import debounce from 'lodash.debounce'
import ProjectApi from '@/services/ProjectApi';

const crtProps = defineProps(['label', 'variant', 'density', 'hideDetails', 'companyId', 'strict', 'isLoaded']);
const projects = ref([])
const model = defineModel({type: Object, default: { projectId: 0, code: ""} })
const selectedProjects = ref()
const loading = ref(false)

const searchProjects = debounce(async (term) => {
    if(crtProps.strict == true && !model.value?.projectId && !crtProps.companyId) 
        return
    loading.value = true
    ProjectApi.search({ offset: 0, limit: 25, search: term, companyId: crtProps.companyId }).then((response) => {
        if (response && response.data && Array.isArray(response.data.projects)) {
            projects.value = response.data.projects;   
        }
    }).finally(() => {
        loading.value = false
        if(term) {
            selectedProjects.value = term
        }
    })
})

onMounted(() => {
    if(model.value && model.value.projectId > 0 && model.value.code) {
        searchProjects(model.value.code)
    }
    else {
        searchProjects(undefined)
    }
})

const handleProjectUpdate = (value) => {
    let project = projects.value.find(x => x.projectId == value);
    if(project) {
        model.value = project;
    }
    else {
        model.value = { projectId: 0, code: ""};
    }
}

watch(() => crtProps.companyId, (first, second) => {
    
    if(crtProps.isLoaded !== false && first != second) {
        selectedProjects.value = null;
        searchProjects(undefined);
    }
});

watch(model, (value) => {
    if(value && value.projectId > 0 && value.code) {
        searchProjects(value.code)
    }
    else {
        searchProjects(undefined)
    }
});

</script>

<template>
    <div :class="crtProps.class">
            <v-autocomplete
                :variant="crtProps.variant ? crtProps.variant : 'solo'" 
                item-title="code"
                item-value="projectId" 
                :density="crtProps.density ? crtProps.density : 'compact'" 
                :label="crtProps.label"
                :loading="loading"
                :items="projects"
                v-model="selectedProjects"
                @update:search="searchProjects"
                @update:model-value="handleProjectUpdate"
                autocomplete="one-time-code"
                :hide-details="crtProps.hideDetails != undefined ? crtProps.hideDetails : true"
                :clearable="true">
            </v-autocomplete>
        </div>
</template>

